var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSalesInv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 16,
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.93016 9.16306V5.7744C5.93016 5.30846 5.54894 4.92724 5.08299 4.92724H1.69433V3.2329H5.93016V1.53857H3.81225V0.691406H2.11791V1.53857H0.847166C0.381225 1.53857 0 1.9198 0 2.38574V5.7744C0 6.24034 0.381225 6.62157 0.847166 6.62157H4.23583V8.3159H0V10.0102H2.11791V10.8574H3.81225V10.0102H5.08299C5.54894 10.0102 5.93016 9.62901 5.93016 9.16306Z",
    fill: "#361A52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99994 13.2834H10.0792V13.2042V12.5028V12.4235H9.99994H7.97485V10.3984V10.3192H7.89561H7.19417H7.11493V10.3984V12.4235H5.08984H5.01061V12.5028V13.2042V13.2834H5.08984H7.11493V15.3085V15.3878H7.19417H7.89561H7.97485V15.3085V13.2834H9.99994Z",
    fill: "#361A52",
    stroke: "#361A52",
    strokeWidth: 0.15847
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesInv);
export default __webpack_public_path__ + "static/media/SalesInv.1fa8592564cad1aa1604f5f1e456df1a.svg";
export { ForwardRef as ReactComponent };